import React from "react";
import FileSaver from 'file-saver';

import Icon from '../images/art/icons/Unknow.png'

import { Button } from "../common";

/* global BigInt */

export default class Settings extends React.Component {
	onClickSave = () => {
		const blob = new Blob([JSON.stringify(this.props.data, (key, value) =>
			typeof value === "bigint" ? value.toString() : value
		)], {type: "text/plain;charset=utf-8"});
		FileSaver.saveAs(blob, "democracydelivery.sav");
	}

	showFile = (e) => {
		e.preventDefault()
		const reader = new FileReader()
		reader.onload = (e) => {
			let data_brut = JSON.parse(e.target.result)
			console.log(data_brut)
			if (data_brut.influence && data_brut.follower && data_brut.ascent && data_brut.clicCount && data_brut.incByClic && data_brut.incByTics && Object.keys(data_brut).indexOf('ticSpeed') > -1 && Object.keys(data_brut).indexOf('playerFlag') > -1 && data_brut.playerName && data_brut.playerColor) {
				let data = {}
				data.playerName = data_brut.playerName
				data.playerColor = data_brut.playerColor
				data.playerFlag = data_brut.playerFlag

				data.influence = BigInt(data_brut.influence)
				data.follower = BigInt(data_brut.follower)
				data.ascent = BigInt(data_brut.ascent)
				data.clicCount = BigInt(data_brut.clicCount)
				data.incByTics = BigInt(data_brut.incByTics)
				data.incByClic = BigInt(data_brut.incByClic)
				data.ticSpeed = parseInt(data_brut.ticSpeed)

				data.storeCount0 = BigInt(data_brut.storeCount0 || 0)
				data.storeCount1 = BigInt(data_brut.storeCount1 || 0)
				data.storeCount2 = BigInt(data_brut.storeCount2 || 0)
				data.storeCount3 = BigInt(data_brut.storeCount3 || 0)
				data.storeCount4 = BigInt(data_brut.storeCount4 || 0)
				data.storeCount5 = BigInt(data_brut.storeCount5 || 0)
				data.storeCount6 = BigInt(data_brut.storeCount6 || 0)
				data.storeCount7 = BigInt(data_brut.storeCount7 || 0)
				data.storeCount8 = BigInt(data_brut.storeCount8 || 0)
				data.storeCount9 = BigInt(data_brut.storeCount9 || 0)
				data.storeCount10 = BigInt(data_brut.storeCount10 || 0)

				data.skillLevel0 = BigInt(data_brut.skillLevel0 || 0)
				data.skillLevel1 = BigInt(data_brut.skillLevel1 || 0)
				data.skillLevel2 = BigInt(data_brut.skillLevel2 || 0)
				data.skillLevel3 = BigInt(data_brut.skillLevel3 || 0)
				data.skillLevel4 = BigInt(data_brut.skillLevel4 || 0)
				data.skillLevel5 = BigInt(data_brut.skillLevel5 || 0)
				data.skillLevel6 = BigInt(data_brut.skillLevel6 || 0)
				data.skillLevel7 = BigInt(data_brut.skillLevel7 || 0)
				data.skillLevel8 = BigInt(data_brut.skillLevel8 || 0)
				data.skillLevel9 = BigInt(data_brut.skillLevel9 || 0)
				data.skillLevel10 = BigInt(data_brut.skillLevel10 || 0)

				data.achievement = (typeof data_brut.achievement === 'object') ? data_brut.achievement : {}

				this.props.updateData(data)
			}
		};
		reader.readAsText(e.target.files[0])
	}

	renderTypeText = (type) => {
		switch (type) {
			case 'follower': return 'Follower'
			case 'clicCount': return 'Click'
			case 'storeCount0': return 'Leaflets'
			case 'storeCount1': return 'Preachers'
			case 'storeCount2': return 'Associations'
			case 'storeCount3': return 'Scientists'
			case 'storeCount4': return 'Medias'
			case 'storeCount5': return 'Politicians'
			case 'storeCount6': return 'Armed forces'
			case 'storeCount7': return 'Cities'
			case 'storeCount8': return 'Planets'
			case 'storeCount9': return 'Galaxies'
			case 'storeCount10': return 'Universes'
			default: return ''
		}
	}

	render() {
		const middleIndex = Math.ceil(this.props.achievement.length / 2);

		const firstHalf = this.props.achievement.slice(0, middleIndex);
		const secondHalf = this.props.achievement.slice(-middleIndex);

		return (
			<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
				<div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflowY: 'auto' }}>
					<div style={{ display: 'flex', flex: 1, flexDirection: 'column', paddingLeft: 20, paddingTop: 20, paddingBottom: 20 }}>
						{
							firstHalf.map((value, key) => {
								return (
									<div key={key} style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
										<div style={{ borderWidth: 2, borderColor: '#6d6d6d', borderStyle: 'solid', marginRight: 10 }}>
											{
												(this.props.data.achievement[key]) ?
													value.picture : <img src={Icon} alt={'Unknow'} style={{ height: 50, width: 50 }} />
											}
										</div>
										<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
											<div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1 }}>{(this.props.data.achievement[key]) ? value.title : ''}</div>
											{(this.props.data.achievement[key]) ? ((value.condition.type === 'follower') ? (value.condition.number / 1000n).toString() : value.condition.number.toString()) : ''} {(this.props.data.achievement[key]) ? this.renderTypeText(value.condition.type) : '???'}
										</div>
									</div>
								)
							})
						}
					</div>

					<div style={{ display: 'flex', flex: 1, flexDirection: 'column', paddingLeft: 20, paddingTop: 20, paddingBottom: 20 }}>
						{
							secondHalf.map((value, key) => {
								return (
									<div key={key} style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
										<div style={{ borderWidth: 2, borderColor: '#6d6d6d', borderStyle: 'solid', marginRight: 10 }}>
											{
												(this.props.data.achievement[key + middleIndex]) ?
													value.picture : <img src={Icon} alt={'Unknow'} style={{ height: 50, width: 50 }} />
											}
										</div>
										<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
											<div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1 }}>{(this.props.data.achievement[key + middleIndex]) ? value.title : ''}</div>
											{(this.props.data.achievement[key + middleIndex]) ? ((value.condition.type === 'follower') ? (value.condition.number / 1000n).toString() : value.condition.number.toString()) : ''} {(this.props.data.achievement[key + middleIndex]) ? this.renderTypeText(value.condition.type) : '???'}
										</div>
									</div>
								)
							})
						}
					</div>
				</div>

				<div style={{ display: 'flex', flexDirection: 'row', border: 0, borderTop: 1, borderColor: '#6d6d6d', borderStyle: 'solid', justifyContent: 'flex-end' }}>
					<Button text={'Reset'} onClick={() => {
						if (window.confirm("WARNING : Resetting will make you loose all your progression so far. Do you want to proceed?")) {
							let values = {
								incByTics: 1000n,
								incByClic: 1000n,
								follower: 0n,
								influence: 0n,
								clicCount: 0n,
								achievement: {},
								playerFlag: 0,
								playerColor: '#000000',
								playerName: ''
							}

							this.props.store.forEach((value, key) => {
								values[`storeCount${key}`] = 0n
							})

							this.props.skill.forEach((value, key) => {
								values[`skillLevel${key}`] = 0n
							})
							this.props.updateData(values)
							setTimeout(() => {
								this.props.reset()
							}, 50)
						}
					}} style={{ borderColor: '#8c1c13', color: '#8c1c13' }} />

					<Button text={'Export'} onClick={this.onClickSave} />

					<label htmlFor={'upload-button'}>
						<div style={{ cursor: 'pointer', width: 100, border: 0, padding: 10, borderColor: '#6d6d6d', borderStyle: 'solid', borderWidth: 2, display: 'flex', justifyContent: 'center' }}>
							Import
						</div>
					</label>
					<input type="file" id="upload-button" style={{display: 'none'}} onChange={(e) => this.showFile(e)} />
				</div>
			</div>
		)
	}
}